import api from './api';
import { Candidate } from '../types/jobVacancy';

const BASE_URL = '/api/candidates';

export const candidateService = {
    async getAllCandidates(): Promise<Candidate[]> {
        const response = await api.get(BASE_URL);
        return response.data;
    },

    async getCandidate(id: number): Promise<Candidate> {
        const response = await api.get(`${BASE_URL}/${id}`);
        return response.data;
    },

    async updateCandidate(id: number, data: Partial<Candidate>): Promise<Candidate> {
        const response = await api.put(`${BASE_URL}/${id}`, data);
        return response.data;
    },

    async searchByEmail(email: string): Promise<Candidate> {
        const response = await api.get(`${BASE_URL}/search`, {
            params: { email }
        });
        return response.data;
    }
}; 